<template>
  <component :is="currentComponent" />
</template>

<script>
import CandidateDetailsTalentfind from "@/pages/CandidateDetailsTalentfind";
import CandidateDetailsTalentfindNew from "@/pages/CandidateDetailsTalentfindNew";
import { getScope } from "@/helpers/helper";

export default {
  data() {
    return {
      currentComponent: null,
    };
  },
  mounted() {
    const role = getScope();
    if (role === "customer_candidate" || role === "system_candidate") {
      this.currentComponent = CandidateDetailsTalentfindNew;
    } else {
      this.currentComponent = CandidateDetailsTalentfind;
    }
  },
};
</script>
